<template>
  <div>
    <van-search
        v-model="Search.Leave_Type_Name"
        show-action
        placeholder="请输入请假类型"
        @search="onSearch"
        @cancel="onCancel"
    />
    <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        :offset="15"
    >
      <div>
        <div v-if="flag === true">
          <div class="weui-cells" style="margin-top: 10px;" v-for="(item, i) in list" :key="i" >
            <a class="weui-cell weui-cell_access" href="javascript:;" @click="toInfo(item.Leave_ID)">
              <div class="weui-media-box__hd">
                <img src="../../assets/images/leave.png" alt="" style="width:30px;margin-right:5px;">
              </div>
              <div class="weui-cell__bd">
                <p>申请职员：<span :class="'span'+ item.This_Status"  >{{item.Staff_Name}}</span><br>请假类型：<span :class="'span'+ item.This_Status">{{item.Leave_Type_Name}}</span></p>
              </div>
              <div class="weui-cell__ft"></div>
            </a>
          </div>
        </div>
        <van-empty description="无此请假，请重新查询" v-else/>
      </div>
    </van-list>
  </div>
</template>

<script>
import { GetLeaveList } from  '@/api/leave'
import store from '@/store'
import {Toast} from "vant";
import {Emas} from "@/assets/js/Emas";

export default {
  name: "Leave",
  data() {
    return {
      list: [],
      type: '',
      value: '',
      flag: true,
      loading: false,   //是否处于加载状态
      finished: false,  //是否已加载完所有数据
      isFinished: false,
      pageCount:'',  //总页数
      Search:{
        PageNo: 1,
        PageSize: 15,
        token:'',
        Dept_ID: null,
        Leave_Type_Name: ''
      }
    };
  },
  created() {
    this.Search.token = store.getters["token"]
    this.Search.Dept_ID = store.getters["Dept_ID"]
    this.fetchData()
    let Staff_Name = sessionStorage.getItem("Staff_Name");
    let DD_ID = sessionStorage.getItem("DD_ID");
    Emas(Staff_Name, DD_ID,"leave", "请假管理", "yywjjoa.yy.gov.cn/leave")
  },
  methods: {
    onLoad() {
      console.log("aaa")
      //加载时页面数量加一
      this.loading = true

      //当页面数大于总页数时，停止加载请求数据
      if (this.Search.PageNo >= this.pageCount) {
        this.loading = false;
        this.isFinished = true;   //数据加载完
      } else {
        this.Search.PageNo++
        this.fetchData()
      }
    },

    async fetchData() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        message: '正在加载',
        forbidClick: true,
      });
      const {data} = await GetLeaveList(this.Search)
      Toast.clear();
      if (data.code === 200) {
        this.flag = true
        this.pageCount = data.pageCount
        this.list = this.list.concat(data.data);
        this.loading = false
      } else {
        this.flag = false
        this.loading = false; //不处于加载状态
        this.isFinished = true;   //数据加载完，不会再处于加载状态
      }
    },

    onSearch(val) {
      this.list = []
      this.Search.Leave_Type_Name = val
      this.fetchData()
    },
    onCancel() {
      this.list = []
      this.Search.PageNo = 1
      this.Search.Leave_Type_Name = ''
      this.fetchData()
    },

    toInfo(Leave_ID) {
      if(Leave_ID !== "") {
        this.$router.push({
          path: 'leaveInfo',
          query: {
            Leave_ID: Leave_ID,
          }
        })
      }
    },
  },
}
</script>

<style scoped>

.weui-media-box__title-after {
  color: #9b9b9b;
  font-size: .65rem;
  float: right;
}

.weui-cell__ft::after {
  content: " ";
  display: inline-block;
  height: 6px;
  width: 6px;
  border-width: 2px 2px 0 0;
  border-color: #c8c8cd;
  border-style: solid;
  -webkit-transform: matrix(.71, .71, -.71, .71, 0, 0);
  transform: matrix(.71, .71, -.71, .71, 0, 0);
  position: relative;
  top: -2px;
  position: absolute;
  top: 50%;
  margin-top: -4px;
  right: 20px;
}
.weui-cell__bd .span0{
  color:red ;
}

.weui-cell__bd .span1{
  color:#5288f5 ;
}

.weui-cell__bd .span2{
  color:#259525 ;
}
</style>